import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import HomePage from "./pages/home.page";
import PolicyPage from "./pages/policy.page";
import NotFoundPage from "./pages/notFound.page";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/policy.html" element={<PolicyPage />} />
                <Route path="/*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
};

export default App;